import { ExportJobResponseDto, ModelEventDto } from '@careapp-group/ng-sdk';
import { CaEntityReducer } from '../entity-state/entity-reducer';
import { BaseFilterType } from '../entity-state/entity-actions-factory';
import { DataExportJobs } from './data-export-jobs.actions';

export class DataExportJobsReducer extends CaEntityReducer<ExportJobResponseDto, BaseFilterType> {}

export const state = new DataExportJobsReducer(DataExportJobs);

export function reducer(...args: any) {
  return state.reducer.apply(state, args);
}
